<section class="main-section">
  <header class="d-flex justify-content-between align-items-center main-heading">
    <div class="d-flex align-items-center">
      <a class="btn btn-link me-3 p-0 d-block d-xl-none back-canvas" data-bs-toggle="offcanvas" href="#offcanvasExample"
        role="button" aria-controls="offcanvasExample">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 7H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
          <path d="M3 12H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
          <path d="M3 17H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
        </svg></a>
      <h3 class="heading-span" *ngIf="currentStep == 0">
        <span>User Centre</span>
      </h3>
      <h3 class="heading-span" *ngIf="currentStep != 0">
        <span class="underline" (click)="this.getMatAccount(pagination)">User Centre</span> / Create MAT Account
      </h3>
    </div>
    <div class="d-flex">
      <div class="d-flex" *ngIf="!openCreateMatForm && currentStep == 0">
        <div class="input-group me-1 user-center-search">
          <span
            class="input-group-text bg-white"
            id="basic-addon1"
            (click)="getMatAccount(pagination)"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.7138 6.8382C18.1647 9.28913 18.1647 13.2629 15.7138 15.7138C13.2629 18.1647 9.28913 18.1647 6.8382 15.7138C4.38727 13.2629 4.38727 9.28913 6.8382 6.8382C9.28913 4.38727 13.2629 4.38727 15.7138 6.8382"
                stroke="#999999" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M19 19L15.71 15.71" stroke="#999999" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </span>
          <input type="text" class="form-control usercenter-searchcontrol bg-white ps-0" placeholder="Search"
            aria-label="Username" [(ngModel)]="searchTerm" aria-describedby="basic-addon1"
            (keyup.enter)="getMatAccount(pagination)" />

        </div>
        <mat-icon matTooltip="Search by MAT Account Name / Package Name / Assign Account Admin"
          class="fs-22 m-2">info</mat-icon>
      </div>
      <div class="d-flex" *ngIf="!openCreateMatForm && currentStep == 0">
        <button type="button" class="btn theme-btn px-2 ms-3 border-sm-0" (click)="sendBulkEmail()">
          <span class="d-block d-sm-none">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFF">
              <path
                d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z" />
            </svg>
          </span>
          <span class="d-none d-sm-block">Send Bulk Email</span>
        </button>
        <button type="button" *ngIf="sectorId == 1" class="btn theme-btn px-2 ms-3 border-sm-0"
          (click)="onCreateMatAccount()">
          <span class="d-block d-sm-none"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M5 12H19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M12 5V19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg></span>
          <span class="d-none d-sm-block">Create MAT Account</span>
        </button>
      </div>

      <div class="d-flex" *ngIf="
          currentStep == steps.AssignPackage && userRole.includes(role.SuperAdmin)
        ">
        <button type="button" class="btn theme-btn-outline px-sm-4 px-2 border-sm-0" (click)="
            currentStep = steps.CreatePackage;
            maxStep = currentStep > maxStep ? currentStep : maxStep;
            showForm = true;
            openCreateMatForm = false;
            openedPackage = true;
          ">
          <span class="d-block d-sm-none"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M5 12H19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M12 5V19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg></span>
          <span class="d-none d-sm-block">Create {{ activeTab }}</span>
        </button>
      </div>
    </div>
  </header>

  <div *ngIf="!openCreateMatForm && currentStep == 0">
    <app-user-center (refreshData)="getMatAccount($event)" [matAccountDetails]="matAccountList"
      (actionTriggered)="actionTriggered($event)" [totalRecords]="totalRecords">
    </app-user-center>
  </div>
  <div class="create-block mw-100" *ngIf="
    !openCreateMatForm &&
    !matAccountList.length &&
    currentStep == 0
  ">
    <img alt="" class="" src="../assets/images/create-mat.svg" />
    <h3 class="my-4 pt-2 content-center">
      Create MAT Account
      <!-- or Individual Schools -->
    </h3>
    <div class="d-flex flex-wrap justify-content-center" *ngIf="sectorId == 1">
      <button type="button" class="btn theme-btn px-4 me-0 me-sm-3 mb-4" (click)="onCreateMatAccount()">
        Create MAT Account
      </button>
      <!-- <button type="button" class="btn theme-btn-outline px-4 ms-0 ms-sm-2 mb-4">
      Create Individual School
    </button> -->
    </div>
  </div>

  <ul class="timeline-horizontal mat-account-timeline d-flex" *ngIf="openCreateMatForm">
    <li
      [ngClass]="{'active': !openedPackage && currentStep == steps.MatAdminDetails, 'completed': !openedPackage ? ((currentStep == steps.AddSchool || currentStep == steps.CreateUser || currentStep == steps.CreateRole) ? true : currentStep == steps.AssignPackage) : true}"
      (click)="goToSelectedStep(steps.MatAdminDetails)">
      <div class="step"><span class="step-timeline">STEP 1</span></div>
      <div class="heading"><span class="step-timeline">MAT Admin Details</span></div>
    </li>
    <li
      [ngClass]="{'active': (currentStep == steps.AssignPackage || currentStep == steps.CreatePackage || currentStep == steps.EditPackage) , 'completed': (currentStep == steps.AddSchool || currentStep == steps.CreateUser || currentStep == steps.CreateRole) }"
      (click)="goToSelectedStep(steps.AssignPackage)">
      <div class="step"><span class="tep-timeline">STEP 2</span></div>
      <div class="heading"><span class="step-timeline">Select Package</span></div>
    </li>
    <li
      [ngClass]="{'active': currentStep == steps.AddSchool , 'completed': currentStep == steps.CreateRole || currentStep == steps.CreateUser}"
      (click)="goToSelectedStep(steps.AddSchool)">
      <div class="step"><span class="step-timeline">STEP 3</span></div>
      <div class="heading"><span class="step-timeline">Add School</span></div>
    </li>
    <li [ngClass]="{'active': currentStep == steps.CreateRole, 'completed': currentStep == steps.CreateUser}"
      (click)="goToSelectedStep(steps.CreateRole)">
      <div class="step"><span class="step-timeline">STEP 4</span></div>
      <div class="heading"><span class="step-timeline">Create Audience</span></div>
    </li>
    <li [ngClass]="{'active': currentStep == steps.CreateUser , 'completed': completedProcess }"
      (click)="goToSelectedStep(steps.CreateUser)">
      <div class="step"><span class="step-timeline">STEP 5</span></div>
      <div class="heading"><span class="step-timeline">Create Member / User</span></div>
    </li>
  </ul>
  <div class="table-responsive package-table-responsive" *ngIf="
      currentStep == steps.AssignPackage ||
      currentStep == steps.CreatePackage ||
      currentStep == steps.EditPackage">
    <app-package [openedFrom]="2" [showForm]="showForm" [selectedPackage]="packageToAssign" [isCurrentTab]="activeTab"
      (packageActionTriggered)="hideNavigationButtons($event)" (packageAssigned)="receivedPackage($event)">
    </app-package>
  </div>

  <div class="mat-account-wrapper">
    <div *ngIf="openCreateMatForm && currentStep == steps.MatAdminDetails" class="content-box non-tab mat-account-tab"
      [formGroup]="matAccountForm">
      <div *ngIf="!setValueForIsEdit(currentStep)" class="text-end">
        <mat-icon matTooltip="Reset Form" class="cursor-pointer" (click)="clearMatAccountForm()">refresh</mat-icon>
      </div>
      <div class="row">
        <div class="col-sm-6 mb-4">
          <div class="mb-0">
            <span class="black-text fs-14 mb-1">MAT Account Name</span>
            <input type="text" [required]="true" formControlName="clientAccountName" class="form-control"
              [readOnly]="isEdit" 
              placeholder="Account name (OPTIONAL: ACRONYM_LOC)"
              [class.is-invalid]="
                matAccountForm.controls['clientAccountName'].invalid &&
                matAccountForm.controls['clientAccountName'].touched" />
          </div>
          <div *ngIf="
              (matAccountForm.controls['clientAccountName'].invalid &&
                matAccountForm.controls['clientAccountName'].touched) ||
              matAccountForm.controls['clientAccountName'].dirty">
            <small *ngIf="matAccountForm.controls['clientAccountName'].errors?.['required']"
              class="text-danger fs-13">MAT Account Name is required</small>
            <small *ngIf="matAccountForm.controls['clientAccountName'].errors?.['pattern']"
              class="text-danger fs-13">Please provide a valid MAT Account Name</small>
          </div>
        </div>
        <!-- Account Reference -->
        <div class="col-sm-6 mb-4">
          <div class="mb-0">
            <span class="black-text fs-14 mb-1">Account Reference</span>
            <input type="text" [required]="true" formControlName="clientReference" class="form-control"
              [readOnly]="isEdit" 
              placeholder="e.g. ACRONYM_LOC"
              [class.is-invalid]="
                matAccountForm.controls['clientReference'].invalid &&
                matAccountForm.controls['clientReference'].touched" />
          </div>
          <div *ngIf="
              (matAccountForm.controls['clientReference'].invalid &&
                matAccountForm.controls['clientReference'].touched) ||
              matAccountForm.controls['clientReference'].dirty">
            <small *ngIf="matAccountForm.controls['clientReference'].errors?.['required']"
              class="text-danger fs-13">Account reference is required</small>
            <small *ngIf="matAccountForm.controls['clientReference'].errors?.['pattern']"
              class="text-danger fs-13">Please provide a valid account reference</small>
          </div>
        </div>
        <!-- Number of MAT Admin -->
        <div class="col-sm-6 mb-4">
          <div class="">
            <div class="d-flex">
              <p class="black-text fs-14 mb-1">Number of MAT Admin to be created</p>
              <mat-icon matTooltip="Provide the number of MAT Admins to be created under this MAT account"
                class="fs-22 ms-2">info</mat-icon>
            </div>
            <div class="input-container">
              <input type="number" min="1" [required]="true" formControlName="numberOfClientAdmin" class="form-control"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57" [class.is-invalid]="
                  matAccountForm.controls['numberOfClientAdmin'].invalid &&
                  matAccountForm.controls['numberOfClientAdmin'].touched" />
            </div>
          </div>
          <div *ngIf="
              (matAccountForm.controls['numberOfClientAdmin'].invalid &&
                matAccountForm.controls['numberOfClientAdmin'].touched) ||
              matAccountForm.controls['numberOfClientAdmin'].dirty">
            <small *ngIf="matAccountForm.controls['numberOfClientAdmin'].errors?.['required']"
              class="text-danger fs-13">Number of MAT Admin to be created is required</small>
          </div>
        </div>
        <div class="col-sm-6 mb-2">
          <div class="mb-4 mat-account-selectoption">
            <div class="d-flex">
              <mat-label class="black-text fs-14 mb-1">Assign Account Admin</mat-label>
              <mat-icon matTooltip="Assign an Account Admin for the MAT Account you are creating"
                class="fs-22 ms-2">info</mat-icon>
            </div>
            <mat-form-field>
              <mat-select [required]="true" formControlName="assignedAccountAdmin" [class.is-invalid]="
                  matAccountForm.controls['assignedAccountAdmin'].invalid &&
                  matAccountForm.controls['assignedAccountAdmin'].touched">
                @for (accountAdmin of accountAdminList; track accountAdmin) {
                <mat-option [value]="accountAdmin">{{
                  accountAdmin.firstName?.concat(" " + accountAdmin.lastName || "")
                  }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <div *ngIf="
                (matAccountForm.controls['assignedAccountAdmin'].invalid &&
                  matAccountForm.controls['assignedAccountAdmin'].touched) ||
                matAccountForm.controls['assignedAccountAdmin'].dirty">
              <small *ngIf="matAccountForm.controls['assignedAccountAdmin'].errors?.['required']"
                class="text-danger fs-13">Account Admin is required</small>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="">
            <span class="black-text fs-14 mb-1">Notes</span>
            <textarea [required]="true" class="form-control" formControlName="notes" rows="3" [class.is-invalid]="
                matAccountForm.controls['notes'].invalid &&
                matAccountForm.controls['notes'].touched
              ">
            </textarea>
            <div *ngIf="
                (matAccountForm.controls['notes'].invalid &&
                  matAccountForm.controls['notes'].touched) ||
                matAccountForm.controls['notes'].dirty
              ">
              <small *ngIf="matAccountForm.controls['notes'].errors?.['required']" class="text-danger fs-13">Notes is
                required
              </small>
              <small *ngIf="matAccountForm.controls['notes'].errors?.['pattern']" class="text-danger fs-13">Please
                provide a valid Note
              </small>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-4">
            <div class="d-flex">
              <span class="black-text fs-14 mb-1">Upload</span>
              <mat-icon matTooltip="Attach documents related to MAT Account" class="ms-2 fs-22">info</mat-icon>
            </div>
            <div class="mt-0 px-3 py-3 custom-file-input">
              <div class="file-input-wrapper">
                <span class="file-name">{{ selectedMatFileCount > 0 ? selectedMatFileCount + ' file(s) selected' :
                  'Click to upload' }}</span>
                <input hidden multiple type="file" #fileInput (change)="onFileSelected($event)" />
                <button class="btn theme-btn px-2 ms-3 border-sm-0" mat-raised-button color="primary"
                  (click)="uploadFromLocal($event)">
                  Upload
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngFor="let matAdminDetail of clientAdminsArray.controls; let i = index">
        <h3 class="d-flex justify-content-between py-2">
          MAT Admin {{ i + 1 }} Details
          <a (click)="onDeleteMatAdmin(i)" class="link-delete">
            <img alt="" class="me-1" src="../assets/images/delete-icon.svg" />Delete</a>
        </h3>
        <ng-container [formGroup]="getFormGroup(matAdminDetail)">
          <div class="row">
            <div class="col-sm-6">
              <div class="mb-4">
                <span class="black-text fs-14 mb-1">First Name</span>
                <input type="text" [required]="true" formControlName="firstName" class="form-control"
                  [readOnly]="isEdit && getFormGroup(matAdminDetail).controls['clientAdminId'].value > 0"
                  [class.is-invalid]="
                    getFormGroup(matAdminDetail).controls['firstName']
                      .invalid &&
                    getFormGroup(matAdminDetail).controls['firstName'].touched" />
                <div *ngIf="
                    (getFormGroup(matAdminDetail).controls['firstName']
                      .invalid &&
                      getFormGroup(matAdminDetail).controls['firstName']
                        .touched) ||
                    getFormGroup(matAdminDetail).controls['firstName'].dirty">
                  <small *ngIf="getFormGroup(matAdminDetail).controls['firstName'].errors?.['required']"
                    class="text-danger fs-13">First Name is required</small>
                  <small *ngIf="getFormGroup(matAdminDetail).controls['firstName'].errors?.['pattern']"
                    class="text-danger fs-13">Please provide a valid First Name</small>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="mb-4">
                <span class="black-text fs-14 mb-1">Last Name</span>
                <input type="text" [required]="true" formControlName="lastName" class="form-control"
                  [readOnly]="isEdit && getFormGroup(matAdminDetail).controls['clientAdminId'].value > 0"
                  [class.is-invalid]="
                    getFormGroup(matAdminDetail).controls['lastName'].invalid &&
                    getFormGroup(matAdminDetail).controls['lastName'].touched" />
                <div *ngIf="
                    (getFormGroup(matAdminDetail).controls['lastName']
                      .invalid &&
                      getFormGroup(matAdminDetail).controls['lastName']
                        .touched) ||
                    getFormGroup(matAdminDetail).controls['lastName'].dirty">
                  <small *ngIf="getFormGroup(matAdminDetail).controls['lastName'].errors?.['required']"
                    class="text-danger fs-13">Last Name is required</small>
                  <small *ngIf="getFormGroup(matAdminDetail).controls['lastName'].errors?.['pattern']"
                    class="text-danger fs-13">Please provide a valid Last Name</small>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="mb-4">
                <span class="black-text fs-14 mb-1">Email Address</span>
                <input type="text" [required]="true" formControlName="emailId" class="form-control"
                  [readOnly]="isEdit && getFormGroup(matAdminDetail).controls['clientAdminId'].value > 0"
                  [class.is-invalid]="
                    getFormGroup(matAdminDetail).controls['emailId'].invalid &&
                    getFormGroup(matAdminDetail).controls['emailId'].touched" />
                <div *ngIf="
                    (getFormGroup(matAdminDetail).controls['emailId'].invalid &&
                      getFormGroup(matAdminDetail).controls['emailId']
                        .touched) ||
                    getFormGroup(matAdminDetail).controls['emailId'].dirty">
                  <small *ngIf="getFormGroup(matAdminDetail).controls['emailId'].errors?.['required']"
                    class="text-danger fs-13">Email Address is required</small>
                  <small *ngIf="getFormGroup(matAdminDetail).controls['emailId'].errors?.['pattern']"
                    class="text-danger fs-13 mt-2">Please provide a valid Email Address</small>
                </div>
              </div>
            </div>
            <div class="col-sm-6 mb-0 contact-number">
              <span class="black-text fs-14 mb-1">Contact Number</span>
              <mat-form-field class="contact-mat-form" appearance="outline" [class.is-invalid]="
                  getFormGroup(matAdminDetail).controls['contactNumber']
                    .invalid &&
                  getFormGroup(matAdminDetail).controls['contactNumber'].touched">
                <ngx-mat-intl-tel-input [enablePlaceholder]="true" [required]="true" [enableSearch]="true"
                  formControlName="contactNumber" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  [preferredCountries]="['gb']">
                </ngx-mat-intl-tel-input>
              </mat-form-field>
              <div *ngIf="
                  (getFormGroup(matAdminDetail).controls['contactNumber']
                    .invalid &&
                    getFormGroup(matAdminDetail).controls['contactNumber']
                      .touched) ||
                  getFormGroup(matAdminDetail).controls['contactNumber'].dirty">
                <small *ngIf="
                    getFormGroup(matAdminDetail).controls['contactNumber']
                      .invalid" class="text-danger fs-13">Please provide a valid Contact Number</small>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="mb-4">
                <div class="d-flex">
                  <span class="black-text fs-14 mb-1">Upload</span>
                  <mat-icon matTooltip="Attach documents related to MAT Admin" class="ms-2 fs-22">info</mat-icon>
                </div>
                <div class="mt-0 px-3 py-3 custom-file-input">
                  <div class="file-input-wrapper">
                    <span class="file-name">{{ selectedMatAdminFileCount[i] > 0 ? selectedMatAdminFileCount[i] + '
                      file(s) selected' : 'Click to upload' }}</span>
                    <input hidden multiple type="file" #adminFileInput (change)="onMatAdminFileSelected($event, i)" />
                    <button class="btn theme-btn px-2 ms-3 border-sm-0" mat-raised-button color="primary"
                      (click)="MatAdminuploadFromLocal($event, i)">
                      Upload
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="col-sm-12">
        <div class="mt-0 mt-sm-0 pt-0 pt-sm-3">
          <button type="button" class="btn theme-btn-outline" [disabled]="
              matAccountForm.invalid ||
              matAccountForm.untouched" (click)="addMatAdminDetail()">
            Add Another Admin
          </button>
          <button type="button" class="btn theme-btn px-3 ms-md-3 ms-0 mt-1 mt-md-0" (click)="downloadFile()">
            <img class="me-2" src="../assets/images/document-upload.svg" alt=""/>Download Template
          </button>
          <input hidden type="file" accept=".xlsx, .xls, .csv" #uploadFileInput (change)="loadExcelData($event)" />
          <button type="button" class="btn theme-btn px-3 ms-md-3 ms-1 mb-0 mt-2 mt-md-0" (click)="bulkUpload()">
            <img class="me-2" src="../assets/images/document-upload.svg" alt="bulkupload" />Bulk Upload
          </button>
        </div>

      </div>
    </div>
    <div *ngIf="openCreateMatForm && currentStep == steps.AddSchool">
      <app-add-school [isEdit]="isEdit" [schoolData]="createdSchoolDetails" [isIndividualEntity] = false 
        [assignedAccountAdminDetails] = "matAccountForm.controls['assignedAccountAdmin'].value!" [accountAdminList]="accountAdminList">
      </app-add-school>
    </div>
    <div *ngIf="openCreateMatForm && currentStep == steps.CreateUser">
      <app-create-user [isEdit]="isEdit" [clientAccountId]="createdMatAccountId" [assignedPackageId]="packageToAssign"
        [schoolData]="matAccountToEdit.schools"></app-create-user>
    </div>
    <div *ngIf="openCreateMatForm && currentStep == steps.CreateRole">
      <app-create-role [openedFromIndividualSchool]="openCreateMatForm" [roleData]="roles" [isEdit]="isEdit"
        [assignedPackageId]="packageToAssign"></app-create-role>
    </div>
    <div class="sticky-btns" *ngIf="openCreateMatForm">
      <div class="row w-100">
        <div class="col-sm-6 text-start">
          <button *ngIf="currentStep != steps.MatAdminDetails" type="button" class="btn theme-btn-outline px-5"
            (click)="handleBack()">
            Back
          </button>
        </div>
        <div class="col-sm-6 text-end">
          <button *ngIf="currentStep == steps.MatAdminDetails && !isEdit" type="button"
            class="btn theme-btn-outline px-5 ms-3" (click)="resetMatAccountCreationProcess()">
            Cancel
          </button>
          <button
            *ngIf="currentStep == steps.AssignPackage || currentStep == steps.AddSchool || currentStep == steps.CreateRole"
            type="button" class="btn theme-btn-outline px-5 ms-3" (click)="partialSave = true; triggerAction()">
            {{ "Submit" }}
          </button>
          <button type="button" class="btn theme-btn px-5 ms-3" (click)="triggerAction()">
            {{ currentStep == steps.CreateUser ? "Submit" : "Next" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</section>